<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ title | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <!-- globalTranslate -->
  <div class="modal-body">
    <p [innerHtml]="body | globalTranslate | sanitize"></p>
  </div>
  <div class="modal-footer justify-content-start">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        class="btn btn-secondary"
        (click)="onConfirm()"
      >
        {{ confirmButton | globalTranslate }}
      </button>
      }
    </div>
    <div class="me-2 ml-2">
      @if (showDecline) {
      <button
        type="button"
        id="dialog"
        class="btn btn-link"
        (click)="onCancel()"
      >
        {{ declineButton | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>